import React, { useCallback } from 'react';

import { Text } from '../../texts';
import { ElementTooltip } from '../../tooltip';
import { getValue } from './input-utils';
import { Styled } from './styled';

const TextItem = (props) => {
  const { content } = props;
  return <Text withEllipsis={true}>{content}</Text>;
};

export const DropDownTextItem = (props) => {
  const {
    onClick,
    id,
    isActive,
    content,
    optionRenderer = (content) => <TextItem content={getValue(content)}/>
  } = props;
  const onItemClick = useCallback(
    (e) => {
      e.stopPropagation();
      onClick(e, id);
    },
    [id]
  );

  const showElementTooltip = content.length >= 20;
  return (
    <Styled.DropDownItem onMouseDown={onItemClick} isActive={isActive}>
      <ElementTooltip
        text={content}
        position={'left'}
        speed={'s'}
        wordBreakAll={true}
        disabled={!showElementTooltip}
      >
        {optionRenderer(content)}
      </ElementTooltip>
    </Styled.DropDownItem>
  );
};
